import {TextTranslations} from '../question';

export interface ExtraRequirementsFile {
  id: string;
  extraRequirementsInquiries: ExtraRequirementsInquiry[];
  documentNames?: string[];
}

export enum ExtraRequirement {
  BLOOD_PROFILE = 'BLOOD_PROFILE',
  URINE_TEST = 'URINE_TEST',
  VITAL_SIGNS = 'VITAL_SIGNS',
  DRIVING_RECORD = 'DRIVING_RECORD',
  MEDICAL_REPORT = 'MEDICAL_REPORT',
  ECG = 'ECG',
  OTHER = 'OTHER',
}

export interface ExtraRequirementsInquiry {
  id: string;
  requirements: ExtraRequirement[];
  note: string;
  createdAt: Date;
}

export const EXTRA_REQUIREMENTS_TRANSLATIONS: Record<ExtraRequirement, TextTranslations> = {
  [ExtraRequirement.BLOOD_PROFILE]: {fr: 'Profil sanguin', en: 'Blood profile'},
  [ExtraRequirement.URINE_TEST]: {fr: `Test d'urine`, en: 'Urine test'},
  [ExtraRequirement.VITAL_SIGNS]: {fr: 'Signes vitaux', en: 'Vital signs'},
  [ExtraRequirement.DRIVING_RECORD]: {fr: 'Dossier de conduite', en: 'Driving record'},
  [ExtraRequirement.MEDICAL_REPORT]: {fr: 'Rapport médical (RMT)', en: 'Medical report (RMT)'},
  [ExtraRequirement.ECG]: {fr: 'ECG', en: 'ECG'},
  [ExtraRequirement.OTHER]: {fr: 'Autre', en: 'Other'},
};
